<div class="container">
    <h2>MEETING AREA - Open discussion</h2>
    <h3>The meeting area is mainly used for ad-hoc meetings. Head over to "schedule a meeting" to <span class="fw-700">pre-book your one-on-one meetings.</span></h3>
    <form class="search-form">
        <div class="bl-form-field">
            <!-- <label for="search">Search</label> -->
            <input type="text" class="bl-form-control" name="searchQuery"
                placeholder="Start typing..."
                [formControl]=searchQuery>
        </div>
    </form>
    <div class="row">
        <div class="col-12 participants-wrapper">
            <h3>Investors</h3>
            <div class="participant" *ngFor="let investor of investors">
                <div class="participant-inner">
                    <h5>{{ investor.displayName || '' }}</h5>
                    <p>{{ investor.company }}</p>
                </div>
                <button class="bl-btn bl-btn-outline"
                    *ngIf="investor.linkedin"
                    (click)="goToUrl(investor.linkedin)"
                    
                    >Social media</button>
            </div>
        </div>
    </div>
</div>

<div class="wave">
    <img src="../../../assets/images/wave2.svg" alt="">
</div>

<div class="container">
    <div class="row">
        <div class="col-12 participants-wrapper">
            <h3>Corporate</h3>
            <div class="participant" *ngFor="let corporate of corporates">
                <div class="participant-inner">
                    <h5>{{ corporate.displayName || '' }}</h5>
                    <p>{{ corporate.company }}</p>
                </div>
                <button class="bl-btn bl-btn-outline"
                    *ngIf="corporate.linkedin"
                    (click)="goToUrl(corporate.linkedin)"
                    
                    >Social media</button>
            </div>
        </div>
    </div>
</div>

<div class="wave">
    <img src="../../../assets/images/wave1.svg" alt="">
</div>

<div class="container">
    <div class="row">
        <div class="col-12 participants-wrapper">
            <h3>Finalists</h3>
            <div class="participant" *ngFor="let finalist of finalists">
                <div class="participant-inner">
                    <h5>{{ finalist.displayName || '' }}</h5>
                    <p>{{ finalist.company }}</p>
                </div>
                <button class="bl-btn bl-btn-outline"
                    *ngIf="finalist.linkedin"
                    (click)="goToUrl(finalist.linkedin)"
                    
                    >Social media</button>
            </div>
        </div>
    </div>
</div>

<div class="wave">
    <img src="../../../assets/images/wave2.svg" alt="">
</div>

<div class="container">
    <div class="row">
        <div class="col-12 participants-wrapper">
            <h3>Start-up or scale-up</h3>
            <div class="participant" *ngFor="let startup of startups">
                <div class="participant-inner">
                    <h5>{{ startup.displayName || '' }}</h5>
                    <p>{{ startup.company }}</p>
                </div>
                <button class="bl-btn bl-btn-outline"
                    *ngIf="startup.linkedin"
                    (click)="goToUrl(startup.linkedin)"
                    
                    >Social media</button>
            </div>
        </div>
    </div>
</div>


<div class="wave">
    <img src="../../../assets/images/wave1.svg" alt="">
</div>

<div class="container">
    <div class="row">
        <div class="col-12 participants-wrapper">
            <h3>University</h3>
            <div class="participant" *ngFor="let university of universities">
                <div class="participant-inner">
                    <h5>{{ university.displayName || '' }}</h5>
                    <p>{{ university.company }}</p>
                </div>
                <button class="bl-btn bl-btn-outline"
                    *ngIf="university.linkedin"
                    (click)="goToUrl(university.linkedin)"
                    
                    >Social media</button>
            </div>
        </div>
    </div>
</div>

<div class="wave">
    <img src="../../../assets/images/wave1.svg" alt="">
</div>

<div class="container">
    <div class="row">
        <div class="col-12 participants-wrapper">
            <h3>Students and learners</h3>
            <div class="participant" *ngFor="let student of students">
                <div class="participant-inner">
                    <h5>{{ student.displayName || '' }}</h5>
                    <p>{{ student.company }}</p>
                </div>
                <button class="bl-btn bl-btn-outline"
                    *ngIf="student.linkedin"
                    (click)="goToUrl(student.linkedin)"
                    
                    >Social media</button>
            </div>
        </div>
    </div>
</div>

<div class="wave">
    <img src="../../../assets/images/wave2.svg" alt="">
</div>

<div class="container">
    <div class="row">
        <div class="col-12 participants-wrapper">
            <h3>Public organisations</h3>
            <div class="participant" *ngFor="let pubOrganisation of pubOrganisations">
                <div class="participant-inner">
                    <h5>{{ pubOrganisation.displayName || '' }}</h5>
                    <p>{{ pubOrganisation.company }}</p>
                </div>
                <button class="bl-btn bl-btn-outline"
                    *ngIf="pubOrganisation.linkedin"
                    (click)="goToUrl(pubOrganisation.linkedin)"
                    
                    >Social media</button>
            </div>
        </div>
    </div>
</div>

<div class="wave">
    <img src="../../../assets/images/wave1.svg" alt="">
</div>

<div class="container">
    <div class="row">
        <div class="col-12 participants-wrapper">
            <h3>Research center</h3>
            <div class="participant" *ngFor="let researcher of researchers">
                <div class="participant-inner">
                    <h5>{{ researcher.displayName || '' }}</h5>
                    <p>{{ researcher.company }}</p>
                </div>
                <button class="bl-btn bl-btn-outline"
                    *ngIf="researcher.linkedin"
                    (click)="goToUrl(researcher.linkedin)"
                    
                    >Social media</button>
            </div>
        </div>
    </div>
</div>

<div class="wave">
    <img src="../../../assets/images/wave1.svg" alt="">
</div>

<div class="container">
    <div class="row">
        <div class="col-12 participants-wrapper">
            <h3>Press and media</h3>
            <div class="participant" *ngFor="let p of press">
                <div class="participant-inner">
                    <h5>{{ p.displayName || '' }}</h5>
                    <p>{{ p.company }}</p>
                </div>
                <button class="bl-btn bl-btn-outline"
                    *ngIf="p.linkedin"
                    (click)="goToUrl(p.linkedin)"
                    
                    >Social media</button>
            </div>
        </div>
    </div>
</div>